<template>
  <div class="page">
    <template v-if="data.state == 0 || data.state == -1 || editing">
      <template v-if="!submited">
        <div class="w400">
          <a-steps :current="currentStep">
            <a-step title="基础信息"></a-step>
            <a-step title="筹款信息"></a-step>
          </a-steps>
        </div>
        <transition name="slide-fade" mode="out-in">
          <template v-if="currentStep == 0">
            <div class="w1100 v-mt-lg">
              <div class="panel">
                <div class="panel-body">
                  <a-form-model class="form-sm" ref="form" :model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
                    <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" v-if="data.state == -1">
                      <span slot="label"></span>
                      <a-alert class="v-mb-sm no-border" type="error">
                        <div slot="message">
                          <div class="font-md text-darkblue flex items-center">
                            <a-icon type="alert" class="v-mr-xs" />
                            此筹款申请已被驳回
                          </div>
                          <div class="flex v-mt-xs">
                            <span class="text-right text-grey">审核意见：</span>
                            <span class="col text-red" v-html="$utils.convertToHtml(data.checkOpinion)"></span>
                          </div>
                        </div>
                      </a-alert>
                    </a-form-model-item>
                    <!-- <a-divider class="bg-primary"></a-divider> -->
                    <!-- <a-divider>基本信息</a-divider> -->
                    <a-row>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            项目名称
                          </span>
                          <a-input v-model="form.prjName" ref="prjName" placeholder="请填写项目名称" style="width: 100%" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            筹款标题
                          </span>
                          <a-input v-model="form.raiseTitle" ref="raiseTitle" placeholder="如：“为乡村儿童提供免费午餐”" style="width: 100%" />
                          <div class="ant-form-explain text-grey">显示在文章或视频旁边的卡片，用于吸引捐赠者</div>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            项目简介
                          </span>
                          <a-textarea :auto-size="{ minRows: 3 }" v-model="form.summary" ref="summary" placeholder="50字简要介绍公益项目，会显示在项目详情页的开头" :rows="2" style="width: 100%" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            项目起止日期
                          </span>
                          <a-range-picker v-model="form.dates" format="YYYY-MM-DD" value-format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onDateRangeChange" ref="datePicker" style="width: 220px" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            项目类型
                          </span>
                          <a-radio-group v-model="form.prjMainType" button-style="solid">
                            <a-radio-button :value="item.name" v-for="item in prjTypes" :key="item.name">{{ item.name }}</a-radio-button>
                          </a-radio-group>
                          <a-divider style="margin: 4px 0"></a-divider>
                          <a-checkbox-group v-model="form.prjSubTypes" style="width: 600px">
                            <a-row :gutter="[4, 4]">
                              <a-col :span="4" v-for="item in subTypes" :key="item">
                                <a-checkbox :value="item">{{ item }}</a-checkbox>
                              </a-col>
                            </a-row>
                          </a-checkbox-group>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            项目宣传图
                          </span>
                          <a-upload
                            :action="`${baseURL}/file/upload`"
                            :data="{
                              params: JSON.stringify({ projectId, raiseId, fileType: 201, fileSign: 'PR' }),
                            }"
                            :file-list="mainFiles"
                            :before-upload="beforeUploadFile"
                            @preview="handlePreviewFile"
                            @change="info => handleUploadChange(info, 1, 'mainFiles')"
                            list-type="picture-card"
                            class="picture-uploader picture-uploader-zt"
                            accept=".png, .jpg, .jpeg, .gif"
                            ref="mainFiles"
                          >
                            <div v-if="mainFiles.length === 0">
                              <a-icon type="plus" />
                              <div class="ant-upload-text">上传图片</div>
                            </div>
                          </a-upload>
                          <div class="ant-form-explain text-grey" style="margin-top: 1px">公益平台和直播、短视频等场景推广展示，支持jpg/png格式，图片尺寸1280x720，大小不超过5MB</div>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            项目轮播图
                          </span>
                          <a-upload
                            :action="`${baseURL}/file/upload`"
                            :data="{
                              params: JSON.stringify({ projectId, raiseId, fileType: 202, fileSign: 'PR' }),
                            }"
                            :file-list="bannerFiles"
                            :before-upload="beforeUploadFile"
                            @preview="handlePreviewFile"
                            @change="info => handleUploadChange(info, 6, 'bannerFiles')"
                            list-type="picture-card"
                            class="picture-uploader picture-uploader-zt2"
                            accept=".png, .jpg, .jpeg, .gif"
                            ref="bannerFiles"
                          >
                            <div v-if="bannerFiles.length < 6">
                              <a-icon type="plus" />
                              <div class="ant-upload-text">上传图片</div>
                            </div>
                          </a-upload>
                          <div class="ant-form-explain text-grey" style="margin-top: -4px">轮播展示，最少3张，最多6张，支持jpg/png格式，建议上传清晰大图</div>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            项目视频
                          </span>
                          <a-upload
                            :action="`${baseURL}/file/upload`"
                            :data="{
                              params: JSON.stringify({ projectId, raiseId, fileType: 203, fileSign: 'PR' }),
                            }"
                            :file-list="videoFiles"
                            :before-upload="beforeUploadFile"
                            @preview="handlePreviewFile"
                            @change="info => handleUploadChange(info, 1, 'videoFiles')"
                            list-type="picture-card"
                            class="picture-uploader picture-uploader-zt"
                            accept=".mp4, .flv, .mov, .avi, .rmvb, .3gp, .wma"
                            ref="videoFiles"
                          >
                            <div v-if="videoFiles.length === 0">
                              <a-icon type="plus" />
                              <div class="ant-upload-text">上传视频</div>
                            </div>
                          </a-upload>
                          <div class="ant-form-explain text-grey" style="margin-top: 1px">视频展示在项目介绍页面顶部，推荐上传1:1尺寸视频</div>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-form-model>
                </div>
              </div>
              <div class="text-center v-mt-sm v-mb-lg">
                <a-space>
                  <a-button icon="swap-right" type="primary" @click="handleNextStep">下一步，填写项目信息</a-button>
                  <a-button icon="close" type="default" @click="load" v-if="editing">取消编辑</a-button>
                  <a-button icon="undo" type="indigo" @click="handleReset" v-else>重置</a-button>
                </a-space>
              </div>
            </div>
          </template>
          <template v-else-if="currentStep == 1">
            <div class="w1100 v-mt-lg">
              <div class="panel">
                <div class="panel-body">
                  <a-form-model class="form-sm" ref="form" :model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
                    <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" v-if="data.state == -1">
                      <span slot="label"></span>
                      <a-alert class="v-mb-sm no-border" type="error">
                        <div slot="message">
                          <div class="font-md text-darkblue flex items-center">
                            <a-icon type="alert" class="v-mr-xs" />
                            此筹款申请已被驳回
                          </div>
                          <div class="flex v-mt-xs">
                            <span class="text-right text-grey">审核意见：</span>
                            <span class="col text-red" v-html="$utils.convertToHtml(data.checkOpinion)"></span>
                          </div>
                        </div>
                      </a-alert>
                    </a-form-model-item>
                    <!-- <a-divider class="bg-primary"></a-divider> -->
                    <a-row>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            是否筹款
                          </span>
                          <a-radio-group v-model="form.acceptAmount">
                            <a-radio :value="true">接受捐款</a-radio>
                            <a-radio :value="false">暂不筹款</a-radio>
                          </a-radio-group>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            公开募捐备案编号
                          </span>
                          <a-input disabled v-model="form.raiseNo" ref="raiseNo" placeholder="慈善中国网站上的“公开募捐备案编号”" style="width: 100%" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            筹款目标
                          </span>
                          <!-- <a-input type="number" placeholder="筹款达到目标后将停止筹款" v-model="form.raiseAmount" ref="raiseAmount" suffix="元" /> -->
                          <div class="input-wrapper">
                            <a-input-number v-model="form.raiseAmount" ref="raiseAmount" style="width: 220px" placeholder="筹款达到目标后将停止筹款" class="no-handler" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear />
                            <span class="input-unit">元</span>
                          </div>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">公益单位</span>
                          每捐赠 <a-input placeholder="捐赠金额" v-model="form.unitAmount" style="width: 100px" /> 元，可为 <a-input v-model="form.unitTarget" placeholder="受助对象，如“贫困学生”" style="width: 200px" /> 提供1
                          <a-input v-model="form.unit" placeholder="量词，如“份”" style="width: 110px" /> <a-input v-model="form.unitText" placeholder="公益单位，如“温暖包”" style="width: 200px" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            项目预算
                          </span>
                          <!-- <a-textarea :auto-size="{ minRows: 6 }" v-model="form.budgets" ref="budgets" placeholder="填写项目预算方案" :rows="4" style="width: 100%" /> -->
                          <span class="font-xs text-grey">填写项目预算方案</span>
                          <!-- <div class="ant-form-explain text-grey" style="margin-top: 1px">项目筹款目标大于100万的项目，需要提交项目捐赠人服务计划</div> -->
                          <tinymce id="myedit" ref="editor" v-model="form.budgets" :file-params="{ projectId, raiseId, fileType: 207, fileSign: 'PR' }" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            票据说明
                          </span>
                          <!-- <a-textarea :auto-size="{ minRows: 6 }" v-model="form.billDesc" ref="billDesc" placeholder="介绍捐款用户如何开具捐赠票据" :rows="2" style="width: 100%" /> -->
                          <span class="font-xs text-grey">介绍捐款用户如何开具捐赠票据</span>
                          <tinymce id="myedit" ref="editor" v-model="form.billDesc" :file-params="{ projectId, raiseId, fileType: 208, fileSign: 'PR' }" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            捐赠金额选项
                          </span>
                          <a-input-group compact>
                            <a-input-number class="text-right" :formatter="value => `${value}元`" v-model="form.raiseAmount1" :min="1" :step="5" style="width: 100px" />
                            <a-input v-model="form.raiseAmountDesc1" placeholder="捐赠描述，如“为山村孩子买一本书”" style="width: 300px; margin-left: 20px" />
                          </a-input-group>
                          <a-input-group compact>
                            <a-input-number class="text-right" :formatter="value => `${value}元`" v-model="form.raiseAmount2" :min="1" :step="5" style="width: 100px" />
                            <a-input v-model="form.raiseAmountDesc2" placeholder="捐赠描述，如“为山村孩子买一套书”" style="width: 300px; margin-left: 20px" />
                          </a-input-group>
                          <a-input-group compact>
                            <a-input-number class="text-right" :formatter="value => `${value}元`" v-model="form.raiseAmount3" :min="1" :step="5" style="width: 100px" />
                            <a-input v-model="form.raiseAmountDesc3" placeholder="捐赠描述，如“资助一名孩子的阅读计划”" style="width: 300px; margin-left: 20px" />
                          </a-input-group>
                          <a-input-group compact>
                            <a-input-number class="text-right" :formatter="value => `${value}元`" v-model="form.raiseAmount4" :min="1" :step="5" style="width: 100px" />
                            <a-input v-model="form.raiseAmountDesc4" placeholder="捐赠描述，如“资助量名孩子的阅读计划”" style="width: 300px; margin-left: 20px" />
                          </a-input-group>
                          <!-- <a-textarea :auto-size="{ minRows: 3 }" v-model="form.billDesc" ref="billDesc" placeholder="介绍捐款用户如何开具捐赠票据" :rows="2" style="width: 100%" /> -->
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col span="24">
                        <a-form-model-item class="form-item-label-vtop" :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label"> 项目传播计划 </span>
                          <div class="ant-form-explain text-grey" style="margin-top: 1px">项目筹款目标大于100万的项目，需要提交项目传播计划</div>
                          <a-upload-dragger
                            class="upload-doc"
                            :action="`${baseURL}/file/upload`"
                            :data="{
                              params: JSON.stringify({ projectId, raiseId, fileType: 204, fileSign: 'PR' }),
                            }"
                            :show-upload-list="{
                              showPreviewIcon: true,
                              showRemoveIcon: true,
                              showDownloadIcon: true,
                            }"
                            :file-list="planFiles"
                            :before-upload="beforeUploadFile"
                            :class="{ 'upload-hideonuploaded': planFiles.length > 0 }"
                            @preview="handlePreviewFile"
                            @change="info => handleUploadChange(info, 1, 'planFiles')"
                            @download="({ fileId, name }) => downloadFile({ fileId, belongId: raiseId, fileSign: 'PR', fileName: name })"
                            accept=".pdf, .doc, .docx"
                            ref="planFiles"
                          >
                            <div class="v-pa-xs" v-if="planFiles.length === 0">
                              <a-icon type="plus" />
                              <p class="font-xs">点击或拖拽文件至此区域上传</p>
                            </div>
                          </a-upload-dragger>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item class="form-item-label-vtop" :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label"> 项目捐赠人服务计划 </span>
                          <div class="ant-form-explain text-grey" style="margin-top: 1px">项目筹款目标大于100万的项目，需要提交项目捐赠人服务计划</div>
                          <a-upload-dragger
                            class="upload-doc"
                            :action="`${baseURL}/file/upload`"
                            :data="{
                              params: JSON.stringify({ projectId, raiseId, fileType: 205, fileSign: 'PR' }),
                            }"
                            :show-upload-list="{
                              showPreviewIcon: true,
                              showRemoveIcon: true,
                              showDownloadIcon: true,
                            }"
                            :file-list="serviceFiles"
                            :before-upload="beforeUploadFile"
                            :class="{ 'upload-hideonuploaded': serviceFiles.length > 0 }"
                            @preview="handlePreviewFile"
                            @change="info => handleUploadChange(info, 1, 'serviceFiles')"
                            @download="({ fileId, name }) => downloadFile({ fileId, belongId: raiseId, fileSign: 'PR', fileName: name })"
                            accept=".pdf, .doc, .docx"
                            ref="serviceFiles"
                          >
                            <div class="v-pa-xs" v-if="serviceFiles.length === 0">
                              <a-icon type="plus" />
                              <p class="font-xs">点击或拖拽文件至此区域上传</p>
                            </div>
                          </a-upload-dragger>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item class="form-item-label-vtop" :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            隐私授权书
                          </span>
                          <a-upload-dragger
                            class="upload-doc"
                            :action="`${baseURL}/file/upload`"
                            :data="{
                              params: JSON.stringify({ projectId, raiseId, fileType: 206, fileSign: 'PR' }),
                            }"
                            :show-upload-list="{
                              showPreviewIcon: true,
                              showRemoveIcon: true,
                              showDownloadIcon: true,
                            }"
                            :file-list="privacyFiles"
                            :before-upload="beforeUploadFile"
                            :class="{ 'upload-hideonuploaded': privacyFiles.length > 0 }"
                            @preview="handlePreviewFile"
                            @change="info => handleUploadChange(info, 1, 'privacyFiles')"
                            @download="({ fileId, name }) => downloadFile({ fileId, belongId: raiseId, fileSign: 'PR', fileName: name })"
                            accept=".pdf, .doc, .docx"
                            ref="privacyFiles"
                          >
                            <div class="v-pa-xs" v-if="privacyFiles.length === 0">
                              <a-icon type="plus" />
                              <p class="font-xs">点击或拖拽文件至此区域上传</p>
                            </div>
                          </a-upload-dragger>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <!-- </a-form-model>
                </div>
              </div>
              <div class="text-center v-mt-sm v-mb-lg">
                <a-space>
                  <a-button icon="swap-left" type="indigo" @click="currentStep = 0">返回上一步</a-button>
                  <a-button icon="swap-right" type="primary" @click="nextStep">下一步，填写详细信息</a-button>
                </a-space>
              </div>
            </div>
          </template>
          <template v-else-if="currentStep == 2">
            <div class="w1100 v-mt-lg">
              <div class="panel">
                <div class="panel-body">
                  <a-form-model class="form-sm" ref="form" :model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }"> -->
                    <a-row>
                      <a-col span="12">
                        <a-form-model-item :colon="false">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            执行负责人
                          </span>
                          <a-input placeholder="填写执行负责人姓名" v-model="form.supervisor" ref="supervisor" style="width: 300px" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            负责人简介
                          </span>
                          <a-textarea :auto-size="{ minRows: 3 }" v-model="form.supervisorDesc" ref="supervisorDesc" placeholder="请简要介绍机构负责人的背景，如头衔、过往经历、荣誉等" :rows="3" style="width: 100%" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            项目描述
                          </span>
                          <!-- <a-textarea :auto-size="{ minRows: 6 }" v-model="form.content" ref="content" placeholder="描述项目背景、目标等信息" style="width: 100%" /> -->
                          <span class="font-xs text-grey">描述项目背景、目标等信息</span>
                          <tinymce id="myedit" ref="editor" v-model="form.content" :file-params="{ projectId, raiseId, fileType: 209, fileSign: 'PR' }" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-form-model>
                </div>
              </div>
              <div class="text-center v-mt-sm v-mb-lg">
                <a-space>
                  <a-button icon="swap-left" type="indigo" @click="currentStep = 0">返回上一步</a-button>
                  <a-button icon="check" type="primary" @click="handleConfirm" :loading="saving">提交筹款申请信息</a-button>
                  <a-button icon="close" type="default" @click="load" v-if="editing">取消编辑</a-button>
                  <!-- <a-button icon="undo" type="indigo" @click="handleReset">重置</a-button> -->
                </a-space>
              </div>
            </div>
          </template>
        </transition>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您填报的筹款申请信息已提交，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="load">查看已提交信息</a-button>
          </template>
        </a-result>
      </template>
    </template>
    <template v-else-if="[1, 2, 3].includes(data.state)">
      <div class="w960 v-mt-lg">
        <div class="panel">
          <div class="panel-body">
            <a-alert banner :show-icon="false" class="v-mb-sm" type="warning"  v-if="data.state == 1">
              <div slot="message" class="text-grey">此筹款申请于 {{ data.applyTime }} 提交，<a-button icon="form" type="indigo" size="small" @click="editing = true">重新编辑</a-button></div>
            </a-alert>
            <table class="table table-plain">
              <tbody>
                <tr>
                  <td colspan="4" class="text-indigo">基础信息</td>
                </tr>
                <tr>
                  <th width="150">项目名称</th>
                  <td width="32%">{{ form.prjName }}</td>
                  <th width="130">募捐标题</th>
                  <td>{{ form.raiseTitle }}</td>
                </tr>
                <tr>
                  <th>项目简介</th>
                  <td colspan="3" v-html="$utils.convertToHtml(form.summary)"></td>
                </tr>
                <tr>
                  <th>项目开始日期</th>
                  <td>{{ form.startDate }}</td>
                  <th>项目结束日期</th>
                  <td>{{ form.endDate }}</td>
                </tr>
                <tr>
                  <th>项目分类</th>
                  <td colspan="3">
                    {{ form.prjMainType }}
                    （{{ form.prjSubTypes.join('、') }}）
                  </td>
                </tr>
                <tr>
                  <th valign="top">项目宣传图</th>
                  <td colspan="3">
                    <file-container :img-size="[220, 120]" :files="data.mainFiles" :belongId="raiseId" fileSign="PR" v-if="data.mainFiles && raiseId"></file-container>
                  </td>
                </tr>
                <tr>
                  <th valign="top">项目轮播图</th>
                  <td colspan="3">
                    <file-container :img-size="[220, 120]" :files="data.bannerFiles" :belongId="raiseId" fileSign="PR" v-if="data.bannerFiles && raiseId"></file-container>
                  </td>
                </tr>
                <tr>
                  <th valign="top">项目视频</th>
                  <td colspan="3">
                    <file-container :img-size="[220, 120]" :files="data.videoFiles" :belongId="raiseId" fileSign="PR" v-if="data.videoFiles && raiseId"></file-container>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="text-indigo">筹款信息</td>
                </tr>
                <tr>
                  <th>是否筹款</th>
                  <td colspan="3">
                    <template v-if="form.acceptAmount">接受捐款</template>
                    <template v-else>暂不筹款</template>
                  </td>
                </tr>
                <tr>
                  <th>公开募捐备案编号</th>
                  <td>{{ form.raiseNo }}</td>
                  <th>筹款目标</th>
                  <td>{{ $utils.thousands(form.raiseAmount, 0) }} 元</td>
                </tr>
                <tr>
                  <th>公益单位</th>
                  <td colspan="3">每捐赠{{ form.unitAmount }}元，可为{{ form.unitTarget }}提供1{{ form.unit }}{{ form.unitText }}</td>
                </tr>
                <tr>
                  <th valign="top">项目预算</th>
                  <td colspan="3" v-html="form.budgets"></td>
                </tr>
                <tr>
                  <th valign="top">票据说明</th>
                  <td colspan="3" v-html="form.billDesc"></td>
                </tr>
                <tr>
                  <th>捐赠金额选项</th>
                  <td colspan="3"></td>
                </tr>
                <tr>
                  <th>项目传播计划</th>
                  <td colspan="3">
                    <file-container :files="data.planFiles" :belongId="raiseId" fileSign="PR" v-if="data.planFiles && raiseId"></file-container>
                  </td>
                </tr>
                <tr>
                  <th>捐赠人服务计划</th>
                  <td colspan="3">
                    <file-container :files="data.serviceFiles" :belongId="raiseId" fileSign="PR" v-if="data.serviceFiles && raiseId"></file-container>
                  </td>
                </tr>
                <tr>
                  <th>隐私授权书</th>
                  <td colspan="3">
                    <file-container :files="data.privacyFiles" :belongId="raiseId" fileSign="PR" v-if="data.privacyFiles && raiseId"></file-container>
                  </td>
                </tr>
                <tr>
                  <th>执行负责人</th>
                  <td colspan="3">{{ form.supervisor }}</td>
                </tr>
                <tr>
                  <th valign="top">负责人简介</th>
                  <td colspan="3" v-html="$utils.convertToHtml(form.supervisorDesc)"></td>
                </tr>
                <tr>
                  <th valign="top">项目描述</th>
                  <td colspan="3" v-html="form.content"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import tinymce from '@/components/tinymce'
import { submitRaise, getRaise } from '@/api/project/funded'
const prjTypes = [
  { name: '乡村振兴', children: ['留守人群', '硬件设施', '社区发展', '产业扶持'] },
  { name: '扶危助困', children: ['物资帮扶', '灾害救援', '灾后重建', '医疗救助', '医疗服务', '女性服务', '助老服务', '特殊人群', '残障关怀'] },
  { name: '生态人文', children: ['动物保护', '生态系统', '气候变化', '污染防治', '自然教育', '绿色社区', '传统文化', '文物保护', '社会创新'] },
  { name: '教育助学', children: ['助学救济', '素质教育', '特殊儿童', '师资支持', '设施建设', '心里教育', '健康成长'] },
]

const form = {
  prjName: '',
  raiseTitle: '',
  summary: '',
  prjMainType: prjTypes[0].name,
  prjSubTypes: [],
  dates: [],
  startDate: undefined,
  endDate: undefined,
  acceptAmount: true,
  raiseNo: '',
  raiseAmount: undefined,
  budgets: '',
  billDesc: '',
  supervisor: '',
  supervisorDesc: '',
  content: '',
  unit: '',
  unitAmount: undefined,
  unitTarget: '',
  unitText: '',
  raiseAmount1: 20,
  raiseAmountDesc1: '',
  raiseAmount2: 30,
  raiseAmountDesc2: '',
  raiseAmount3: 50,
  raiseAmountDesc3: '',
  raiseAmount4: 100,
  raiseAmountDesc4: '',
}
export default {
  props: {
    raiseId: {
      type: Number,
      required: true,
    },
  },
  components: {
    tinymce,
  },
  data() {
    return {
      projectId: undefined,
      // raiseId: null,
      currentStep: 0,
      submited: false,
      editing: false,
      saving: false,
      data: {},
      form: {
        ...form,
      },
      prjTypes,
      mainFiles: [],
      bannerFiles: [],
      videoFiles: [],
      planFiles: [],
      serviceFiles: [],
      privacyFiles: [],
    }
  },
  computed: {
    subTypes: vm => prjTypes.find(d => d.name === vm.form.prjMainType).children,
  },
  methods: {
    load() {
      this.loading = true
      this.editing = false
      getRaise(this.raiseId).then(({ data }) => {
        if (data.success) {
          let result = data.result
          let { projectId, raiseInfo, raiseNo, files } = result
          this.form = { ...form, ...JSON.parse(raiseInfo || '{}') }
          if (raiseNo) {
            this.form.raiseNo = raiseNo
          }
          result.mainFiles = files.filter(file => file.fileType === 201)
          result.bannerFiles = files.filter(file => file.fileType === 202)
          result.videoFiles = files.filter(file => file.fileType === 203)
          result.planFiles = files.filter(file => file.fileType === 204)
          result.serviceFiles = files.filter(file => file.fileType === 205)
          result.privacyFiles = files.filter(file => file.fileType === 206)
          this.data = result
          this.projectId = projectId
          this.mainFiles = files
            .filter(file => file.fileType === 201)
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.bannerFiles = files
            .filter(file => file.fileType === 202)
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.videoFiles = files
            .filter(file => file.fileType === 203)
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.planFiles = files
            .filter(file => file.fileType === 204)
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.serviceFiles = files
            .filter(file => file.fileType === 205)
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.privacyFiles = files
            .filter(file => file.fileType === 206)
            .map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PR',
              belongId: file.raiseId,
              ...file,
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
            }))
          this.submited = false
        }
      })
    },
    onDateRangeChange(date, dateString) {
      let [startDate, endDate] = dateString
      this.form.startDate = startDate
      this.form.endDate = endDate
    },
    handleNextStep() {
      let { prjName, raiseTitle, summary, startDate, prjSubTypes } = this.form
      let { mainFiles, bannerFiles } = this
      this.$message.destroy()
      if (prjName.trim() === '') {
        this.$message.warning('请输入项目名称')
        this.$refs.prjName.focus()
        return
      }
      if (raiseTitle.trim() === '') {
        this.$message.warning('请输入筹款标题')
        this.$refs.raiseTitle.focus()
        return
      }
      if (summary.trim() === '') {
        this.$message.warning('请输入项目简介')
        this.$refs.summary.focus()
        return
      }
      if (!startDate) {
        this.$message.warning('请选择项目起止日期')
        this.$refs.datePicker.focus()
        return
      }
      if (prjSubTypes.length == 0) {
        this.$message.warning('请选择项目类型')
        return
      }
      if (this.mainFiles.length === 0) {
        this.$message.warning('请上传项目宣传图')
        this.$refs.mainFiles.$el.classList.add('uploader-empty')
        return
      }
      if (this.bannerFiles.length === 0) {
        this.$message.warning('请上传项目轮播图')
        this.$refs.bannerFiles.$el.classList.add('uploader-empty')
        return
      }
      if (this.bannerFiles.length < 3) {
        this.$message.warning('请上传至少3张项目轮播图')
        this.$refs.bannerFiles.$el.classList.add('uploader-empty')
        return
      }
      this.currentStep += 1
    },
    handleConfirm() {
      let { acceptAmount, raiseAmount, budgets, billDesc, supervisor, supervisorDesc, content } = this.form
      let { privacyFiles } = this
      this.$message.destroy()
      if (acceptAmount && !raiseAmount) {
        this.$message.warning('请输入筹款目标金额')
        this.$refs.raiseAmount.focus()
        return
      }
      if (budgets.trim() === '') {
        this.$message.warning('请输入项目预算')
        // this.$refs.budgets.focus()
        return
      }
      if (billDesc.trim() === '') {
        this.$message.warning('请输入票据说明')
        // this.$refs.summary.focus()
        return
      }
      if (privacyFiles.length === 0) {
        this.$message.warning('请上传隐私授权书')
        this.$refs.privacyFiles.$el.classList.add('uploader-empty')
        return
      }
      if (supervisor.trim() === '') {
        this.$message.warning('请输入执行负责人')
        this.$refs.supervisor.focus()
        return
      }
      if (supervisorDesc.trim() === '') {
        this.$message.warning('请输入负责人简介')
        this.$refs.supervisorDesc.focus()
        return
      }
      if (content.trim() === '') {
        this.$message.warning('请输入项目描述')
        // this.$refs.summary.focus()
        return
      }
      this.$confirm({
        title: '确认提交筹款申请信息？',
        centered: true,
        onOk: () => {
          this.handleSubmit()
        },
      })
    },
    handleSubmit() {
      this.saving = true
      let { mainFiles, videoFiles, bannerFiles, planFiles, serviceFiles, privacyFiles } = this
      let files = this.mainFiles
        .map(({ fileId }) => ({ fileId }))
        .concat(mainFiles.map(({ fileId }) => ({ fileId })))
        .concat(videoFiles.map(({ fileId }) => ({ fileId })))
        .concat(bannerFiles.map(({ fileId }) => ({ fileId })))
        .concat(planFiles.map(({ fileId }) => ({ fileId })))
        .concat(serviceFiles.map(({ fileId }) => ({ fileId })))
        .concat(privacyFiles.map(({ fileId }) => ({ fileId })))
      let params = {
        files,
        raiseId: this.raiseId,
        raiseInfo: JSON.stringify(this.form),
        projectId: this.projectId,
      }
      this.$message.destroy()
      submitRaise(params).then(({ data }) => {
        this.saving = false
        if (data.success) {
          this.submited = true
          this.$emit('submit')
        } else {
          this.$message.warning(data.msg)
        }
      })
    },
    handleReset() {},
    handleUploadChange(info, count, ref) {
      if (ref && this.$refs[ref]) {
        this[ref] = this.handleUploadFile(info, count)
        this.$refs[ref].$el.classList.remove('uploader-empty')
      }
    },
  },
  created() {
    this.load()
  },
}
</script>

<style lang="stylus"></style>
